import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock, Mail, ArrowRight } from 'lucide-react';
import API from '../lib/api';
import { useToast } from '../hooks/use-toast';
import { useAuth } from '../context/AuthContext';

const AdminLogin = () => {
  const nav = useNavigate();
  const { toast } = useToast();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('admin@skyway.green');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await signIn({ email, password });
      if (u.role !== 'admin') {
        toast({ title: 'Access denied', description: 'This account is not an administrator.' });
        return;
      }
      toast({ title: 'Welcome, Admin', description: 'Signed in to control panel.' });
      nav('/admin/panel');
    } catch (err) {
      toast({ title: 'Login failed', description: err.response?.data?.detail || 'Invalid credentials' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#040d08] grid-pattern flex items-center justify-center p-4 relative">
      <div className="absolute inset-0 radial-fade" />
      <div className="relative w-full max-w-[440px] rounded-3xl border border-emerald-900/60 bg-gradient-to-b from-[#0a1e14]/95 to-[#040d08]/95 backdrop-blur p-8 shadow-2xl green-glow">
        <div className="flex items-center gap-2 text-emerald-300">
          <Shield size={18} />
          <span className="text-[11px] font-semibold uppercase tracking-[0.18em]">Administrator Access</span>
        </div>
        <h1 className="mt-3 font-serif text-white text-3xl tracking-tight">SkyWay Green<br /><span className="italic text-emerald-300">Control Center</span></h1>
        <p className="mt-2 text-[13px] text-emerald-100/60">Sign in with your administrator credentials to manage the ecosystem.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="block text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-300 mb-2">Admin Email</span>
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-emerald-400" />
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="dark-input pl-9" />
            </div>
          </label>
          <label className="block">
            <span className="block text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-300 mb-2">Password</span>
            <div className="relative">
              <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-emerald-400" />
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required placeholder="Enter admin password" className="dark-input pl-9" />
            </div>
          </label>
          <button disabled={loading} type="submit" className="w-full mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-500 hover:bg-emerald-400 disabled:opacity-60 text-emerald-950 font-semibold py-3.5 transition">
            {loading ? 'Signing in…' : 'Sign In to Panel'} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
